/**
 * Normalización de teléfonos argentinos.
 *
 * FORMATO CANÓNICO: dígitos sin '+', con prefijo 549.
 * Ejemplo: 5493541391105
 *
 * Este formato es compatible con:
 *  - WhatsApp API (wa.me/5493541391105)
 *  - Bot Maja (busca por telefonoNorm sin '+')
 *  - Firestore (string, sin caracteres especiales)
 *
 * Casos que resuelve (todos producen '5493541391105'):
 *   3541391105         → local 10 dígitos
 *   03541391105        → con 0 de discado
 *   543541391105       → código país sin 9 móvil
 *  +543541391105       → idem con +
 *   5493541391105      → ya normalizado
 *  +5493541391105      → ya normalizado con +
 *   3541 391 105       → con espacios
 *   3541-391-105       → con guiones
 *  (3541) 391105       → con paréntesis
 *
 * Números de 8 dígitos o menos: devolver tal cual (no bloquear el flujo).
 */
export function normalizarTelefono(raw = '') {
  if (!raw) return ''

  // Quitar todo lo que no sea dígito
  let digits = raw.replace(/\D/g, '')

  // Quitar cero de discado nacional inicial
  if (digits.startsWith('0')) digits = digits.slice(1)

  // Ya tiene 549 y longitud correcta (13 dígitos: 549 + área 3 + número 7)
  if (digits.startsWith('549') && digits.length === 13) return digits

  // Tiene 549 pero longitud inesperada → devolver como vino
  if (digits.startsWith('549') && digits.length !== 13) return digits

  // Empieza con 54 sin el 9 móvil (11 dígitos: 54 + área 3 + número 7 = 12 → raro)
  // O 54 + área 2 + número 8 = 12
  if (digits.startsWith('54') && digits.length >= 11 && digits.length <= 12) {
    const sinPais = digits.slice(2)
    return '549' + sinPais
  }

  // Número local: área (2–4) + número = 8–10 dígitos totales
  if (digits.length >= 8 && digits.length <= 10) {
    return '549' + digits
  }

  // Fallback: devolver dígitos limpios sin alterar
  return digits
}

/**
 * Formatea para mostrar: +54 9 3541 391 105
 * Solo para UI — no usar como clave de búsqueda.
 */
export function formatearTelefono(normalizado = '') {
  if (!normalizado || normalizado.length < 10) return normalizado
  const d = normalizado.replace(/\D/g, '')
  if (d.startsWith('549') && d.length === 13) {
    return `+54 9 ${d.slice(3, 7)} ${d.slice(7, 10)} ${d.slice(10)}`
  }
  return `+${d}`
}

/**
 * Pruebas unitarias inline — ejecutar en consola del browser o Node:
 *
 *   import { normalizarTelefono } from './phoneUtils'
 *   const ESPERADO = '5493541391105'
 *   const casos = [
 *     '3541391105', '03541391105', '543541391105', '+543541391105',
 *     '5493541391105', '+5493541391105',
 *     '3541 391 105', '3541-391-105', '(3541) 391105',
 *   ]
 *   casos.forEach(c => {
 *     const r = normalizarTelefono(c)
 *     console.assert(r === ESPERADO, `FAIL: "${c}" → "${r}" (esperado: "${ESPERADO}")`)
 *     console.log(r === ESPERADO ? '✓' : '✗', c, '→', r)
 *   })
 */
